/**
 * RS Go plateform v1.0.0 - React APPLICATION
 * Copyright 2017-present, My Edition Company SAS -> for RoyalSpeed SARL
 * All rights reserved.
 *
 * @authors: José Barcelon Godfrey
 * Paris, France
 */

import React, {Component, PropTypes} from 'react'
import Toggle from 'react-toggle'
import ReactTooltip from 'react-tooltip'

import f_options from './_foptions.jsx';

export default class FormationInformation extends Component {
  constructor(props){
    super(props);
    this.handleDataChange = this.handleDataChange.bind(this)
    this.validationForm = this.validationForm.bind(this)
    this.handleErrorMsg = this.handleErrorMsg.bind(this)
    this.checkInput = this.checkInput.bind(this)
    this.state = {
      prospect_formation: this.props.f,
      prospect_ecole: this.props.fieldValues.prospect_ecole,
      prospect_code: this.props.fieldValues.prospect_code,
      prospect_formation_manu: this.props.fieldValues.prospect_formation_manu,
      prospect_formation_bateau: this.props.fieldValues.prospect_formation_bateau,
      prospect_formation_avion: this.props.fieldValues.prospect_formation_avion,
      prospect_permis_ppl: this.props.fieldValues.prospect_permis_ppl,
      prospect_heure_conduite: this.props.fieldValues.prospect_heure_conduite,
      prospect_heure_vol: this.props.fieldValues.prospect_heure_vol,
      prospect_heure_navigation: this.props.fieldValues.prospect_heure_navigation,
      prospect_preference_contact: this.props.fieldValues.prospect_preference_contact,
      prospect_preference_pass: this.props.fieldValues.prospect_preference_pass,
      prospect_permis_statut: this.props.fieldValues.prospect_permis_statut,
      prospect_nb_heure_conduite: this.props.fieldValues.prospect_nb_heure_conduite,
      prospect_nb_heure_navigation: this.props.fieldValues.prospect_nb_heure_navigation,
      prospect_nb_heure_vol: this.props.fieldValues.prospect_nb_heure_vol,
      error_message: false
    }
  }
  handleDataChange(){

    var message = this.refs.message.value
    message == "" ? message = null : message = this.refs.message.value

    // ----- VOITURE -----

    // Auto-ecole (bool)
    if(this.refs.ecole != undefined){
      var ecole = this.refs.ecole.input.checked
      this.setState({
        prospect_ecole: ecole
      })
    }else{
      var ecole = false
    }

    // Code de la route (bool)
    if(this.refs.code != undefined){
      var code = this.refs.code.input.checked
      this.setState({
        prospect_code: code
      })
    }else{
      var code = false
    }

    // Nb année code (int)
    var nbYearCode = this.refs.nbYearCode
    nbYearCode != undefined ? nbYearCode = nbYearCode.value : nbYearCode = null

    // Conduite (bool)
    if(this.refs.hourDrive != undefined){
      var hourDrive = this.refs.hourDrive.input.checked
      this.setState({
        prospect_heure_conduite: hourDrive
      })
    }else{
      var hourDrive = false
    }

    // Nb heure de conduite (int)
    if(this.refs.nbHourDrive != undefined){
      var nbHourDrive = this.refs.nbHourDrive
      nbHourDrive = nbHourDrive.value
      this.setState({
        prospect_nb_heure_conduite: nbHourDrive
      })
    }else{
      var nbHourDrive = null
    }

    // Formation manuelle (bool)
    if(this.refs.formationManu != undefined){
      var formationManu = this.refs.formationManu.input.checked
      this.setState({
        prospect_formation_manu: formationManu
      })
    }else{
      var formationManu = false
    }

    // Statut du permis (string)
    var rsp = document.getElementsByName('annul'), statutPermis
    if(rsp != undefined){
      for(var i = 0; i < rsp.length; i++){
        if(rsp[i].checked){
          statutPermis = rsp[i].value
          this.setState({
            prospect_permis_statut: rsp[i].value
          })
        }
      }
    }else{
      statutPermis = null
    }

    // ----- BATEAU -----

    // Bateau ecole (bool)
    if(this.refs.bateauEcole != undefined){
      var bateauEcole = this.refs.bateauEcole.input.checked
      this.setState({
        prospect_formation_bateau: bateauEcole
      })
    }else{
      var bateauEcole = false
    }

    // Heure de navigation (bool)
    if(this.refs.hourNav != undefined){
      var hourNav = this.refs.hourNav.input.checked
      this.setState({
        prospect_heure_navigation: hourNav
      })
    }else{
      var hourNav = false
    }

    // Nombre heure de navigation (int)
    if(this.refs.nbHourNav != undefined){
      var nbHourNav = this.refs.nbHourNav
      nbHourNav = nbHourNav.value
      this.setState({
        prospect_nb_heure_navigation: nbHourNav
      })
    }else{
      var nbHourNav = null
    }

    // ----- AVION / HELICO -----

    // Avion ecole (bool)
    if(this.refs.avionEcole != undefined){
      var avionEcole = this.refs.avionEcole.input.checked
      this.setState({
        prospect_formation_avion: avionEcole
      })
    }else{
      var avionEcole = false
    }

    // Heure de vol (bool)
    if(this.refs.hourFlight != undefined){
      var hourFlight = this.refs.hourFlight.input.checked
      this.setState({
        prospect_heure_vol: hourFlight
      })
    }else{
      var hourFlight = false
    }

    // Licence PLL (bool)
    if(this.refs.licencePPL != undefined){
      var licencePPL = this.refs.licencePPL.input.checked
      this.setState({
        prospect_permis_ppl: licencePPL
      })
    }else{
      var licencePPL = false
    }

    // Nombre heure de vol (int)
    var nbHourFlight = this.refs.nbHourFlight
    nbHourFlight != undefined ? nbHourFlight = nbHourFlight.value : nbHourFlight = null

    if(this.refs.nbHourFlight != undefined){
      var nbHourFlight = this.refs.nbHourFlight
      nbHourFlight = nbHourFlight.value
      this.setState({
        prospect_nb_heure_vol: nbHourFlight
      })
    }else{
      var nbHourFlight = null
    }

    // ----- PREFERENCE -----

    // Preference de passage (string)
    var rpp = document.getElementsByName('province')
    if(rpp != undefined){
      var prefPass
      for(var i = 0; i < rpp.length; i++){
        if(rpp[i].checked){
          prefPass = rpp[i].value
          this.setState({
            prospect_preference_pass: rpp[i].value
          })
        }
      }
    }else{
      var prefPass = null
    }

    // Preference de prise de contact (string)
    var rpc = document.getElementsByName('ecole')
    if(rpc != undefined){
      var prefCont
      for(var i = 0; i < rpc.length; i++){
        if(rpc[i].checked){
          prefCont = rpc[i].value
          this.setState({
            prospect_preference_contact: rpc[i].value
          })
        }
      }
    }else{
      var prefCont = null
    }

    // ----- Data du formulaire -----

    var data = {
      prospect_ecole: ecole,
      prospect_code: code,
      prospect_year_code: nbYearCode,
      prospect_formation_manu: formationManu,
      prospect_heure_conduite: hourDrive,
      prospect_nb_heure_conduite: nbHourDrive,
      prospect_preference_pass: prefPass,
      prospect_preference_contact: prefCont,
      prospect_message: message,
      prospect_permis_statut: statutPermis,
      prospect_formation_bateau: bateauEcole,
      prospect_formation_avion: avionEcole,
      prospect_nb_heure_vol: nbHourFlight,
      prospect_permis_ppl: licencePPL,
      prospect_heure_vol: hourFlight,
      prospect_heure_navigation: hourNav,
      prospect_nb_heure_navigation: nbHourNav,
      prospect_formation: this.props.f
    }

    // ----- MAJ des data du formulaire -----

    this.props.saveValues(data)
  }
  validationForm(){
    if(this.props.f == 1 || this.props.f == 2){ // permis manuel (1) ou permis auto (2)
      var prefContact = this.state.prospect_preference_contact,
          prefPass = this.state.prospect_preference_pass,
          conduite = this.state.prospect_heure_conduite,
          nbConduite = this.state.prospect_nb_heure_conduite
      if(prefContact != null && prefPass != null){
        if(conduite == true){
          nbConduite = parseFloat(nbConduite)
          if(Number.isInteger(nbConduite) && nbConduite <= 100){
            return true
          }else{
            return false
          }
        }else{
          return true
        }
      } else {
        return false
      }
    }else if(this.props.f == 3 || this.props.f == 4){ // permis moto (3) ou code seul (4)
      var prefContact = this.state.prospect_preference_contact,
          conduite = this.state.prospect_heure_conduite,
          nbConduite = this.state.prospect_nb_heure_conduite
      if(prefContact != null){
        if(conduite == true){
          nbConduite = parseFloat(nbConduite)
          if(Number.isInteger(nbConduite) && nbConduite <= 100){
            return true
          }else{
            return false
          }
        }else{
          return true
        }
      } else {
        return false
      }
    }else if(this.props.f == 7){ // permis bateau (7)
      var prefContact = this.state.prospect_preference_contact,
          navigation = this.state.prospect_heure_navigation,
          nbNavigation = this.state.prospect_nb_heure_navigation
      if(prefContact != null){
        if(navigation == true){
          nbNavigation = parseFloat(nbNavigation)
          if(Number.isInteger(nbNavigation) && nbNavigation <= 100){
            return true
          }else{
            return false
          }
        }else{
          return true
        }
      } else {
        return false
      }
    }else if(this.props.f == 8 || this.props.f == 9){ // permis helico (8) ou avion (9)
      var prefContact = this.state.prospect_preference_contact,
          vol = this.state.prospect_heure_vol,
          nbVol = this.state.prospect_nb_heure_vol
      if(prefContact != null){
        if(vol == true){
          nbVol = parseFloat(nbVol)
          if(Number.isInteger(nbVol) && nbVol <= 100){
            return true
          }else{
            return false
          }
        }else{
          return true
        }
      } else {
        return false
      }
    }else if(this.props.f == 6){ // annulation de permis (6)
      if(this.state.prospect_preference_contact != null && this.state.prospect_permis_statut != null){
        return true
      } else {
        return false
      }
    }else if(this.props.f == 5){ // recup de points (5)
      if(this.state.prospect_preference_contact != null){
        return true
      } else {
        return false
      }
    }else{
      return false
    }
  }
  handleErrorMsg(msg){
    if(msg != false){
      this.setState({
        error_message: <span className="errorMsg">{msg}</span>
      })
    }else{
      this.setState({
        error_message: msg
      })
    }
  }
  checkInput(e){
    if(Number(e.target.value) >= 100 && e.keyCode != 8 && e.keyCode != 40 && e.keyCode != 37 && e.keyCode != 39){
      this.handleErrorMsg("Le nombre d'heures doit être inférieur à 100");
      e.preventDefault()
    }else if(isNaN(e.target.value)){
      this.handleErrorMsg("Ceci n'est pas un nombre ;)");
    }else{
      this.handleErrorMsg(false)
    }
  }
  render(){
    var errorMsg = this.state.error_message
    var that = this
    var agency = this.props.agency
    var validForm = this.validationForm()
    var displayNbHourDrive,
        displayNbHourFlight,
        displayNbHourNav,
        displayYearCode
    this.state.prospect_code == true ? displayYearCode = "block" : displayYearCode = "none"
    this.state.prospect_heure_conduite == true ? displayNbHourDrive = "block": displayNbHourDrive = "none"
    this.state.prospect_heure_vol == true ? displayNbHourFlight = "block": displayNbHourFlight = "none"
    this.state.prospect_heure_navigation == true ? displayNbHourNav = "block": displayNbHourNav = "none"

    var selectedOption = this.props.f <= 3 ? f_options.main["_fopt"+this.props.f] : f_options.other["_fopt"+this.props.f]

    var btnNext
    validForm == true ? btnNext = <button className="go-button go-green pull-right" onClick={() => {this.props.next(2)}}>Etape suivante<span className="rs-icon-angle-right"></span></button> : btnNext = <button data-tip="Veuillez remplir les champs obligatoires." data-class="tooltip-info" className="go-button go-green pull-right disabled">Etape suivante<span className="rs-icon-angle-right"></span></button>

    return <div className="go-form-step">
      <div className="go-step-header">
        <button className="go-button go-green pull-left" onClick={() => {this.props.prev(2)}}><span className="rs-icon-angle-left"></span>Etape précédente</button>
        {btnNext}
        <h1 className='center-text'>2. Quel est votre parcours ?</h1>
      </div>
      <div className="row">
        <div className="four columns">
          <div className="go-card formation-option smaller">
            <div className={"option-graphic "+selectedOption.icon}>
            </div>
            <div>
              <p>Formation choisie:</p>
              <h2>{selectedOption.name}</h2>
            </div>
          </div>
        </div>
        <div className="eight columns">
          <div className="row info-form">
            <p>Remplissez ce formulaire afin d'accéder à l'étape suivante ⚡️</p>
          </div>
          <div className="container-toggle-form">
          {
            (this.props.f <= 4) ?
              <div>
                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="ecole" className="lnk">J'ai déjà été inscrit dans une auto-école</label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="ecole"
                      defaultChecked={this.props.fieldValues.prospect_ecole}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="ecole"/>
                    <p className="label-toggle" htmlFor='test'>{this.state.prospect_ecole == true ? "Oui" : "Non"}</p>
                  </div>
                </div>
                {
                  this.props.f != 4 ?
                    <div className="row toggle-form">
                      <div className="nine columns">
                        <label htmlFor="code" className="lnk">J'ai déjà obtenu mon code de la route</label>
                      </div>
                      <div className="three columns">
                        <Toggle
                          id="code"
                          defaultChecked={this.props.fieldValues.prospect_code}
                          icons={false}
                          onChange={this.handleDataChange}
                          ref="code"/>
                        <p className="label-toggle" htmlFor='test'>{this.state.prospect_code == true ? "Oui" : "Non"}</p>
                      </div>
                      <div className="twelve columns" style={{display: displayYearCode}}>
                        <label htmlFor="nbYearCode" className="lnk">Depuis combien de temps ?</label>
                        <select id="nbYearCode"
                                ref="nbYearCode"
                                defaultValue={this.props.fieldValues.prospect_year_code === null ? "" : this.props.fieldValues.prospect_year_code}
                                onChange={this.handleDataChange}>
                          <option value="moins de 4 ans">moins de 4 ans</option>
                          <option value="entre 4 et 5 ans">entre 4 et 5 ans</option>
                          <option value="plus de 5 ans">plus de 5 ans (code plus valable)</option>
                        </select>
                      </div>
                    </div>
                    : null
                }
                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="hourDrive" className="lnk">J'ai déjà effectué des heures de conduite</label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="hourDrive"
                      defaultChecked={this.props.fieldValues.prospect_heure_conduite}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="hourDrive"/>
                    <p className="label-toggle">{this.state.prospect_heure_conduite == true ? "Oui" : "Non"}</p>
                  </div>
                  <div className="twelve columns" style={{display: displayNbHourDrive}}>
                    <label htmlFor="nbHourDrive" className="lnk">Combien d'heure(s) ?<span className="reqField">*</span></label>
                    <input id="nbHourDrive"
                           type="number"
                           ref="nbHourDrive"
                           min="1" max="100"
                           defaultValue={this.props.fieldValues.prospect_nb_heure_conduite != null ? this.props.fieldValues.prospect_nb_heure_conduite : ""}
                           onChange={() => {this.handleDataChange(); this.validationForm(); }}
                           onKeyDown={(e) =>  {this.checkInput(e)}}/>
                    {errorMsg != false ? this.state.error_message : null}
                  </div>
                </div>
              </div>
              : null
          }

          { this.props.f == 2 ? 
              <div className="row toggle-form">
                <div className="nine columns">
                  <label htmlFor="formationManu" className="lnk">J'ai souhaiterai également passer la formation 7h supplémentaires pour boite manuelle</label>
                </div>
                <div className="three columns">
                  <Toggle
                    id="formationManu"
                    defaultChecked={this.props.fieldValues.prospect_formation_manu}
                    icons={false}
                    onChange={this.handleDataChange}
                    ref="formationManu"/>
                  <p className="label-toggle" htmlFor='test'>{this.state.prospect_formation_manu == true ? "Oui" : "Non"}</p>
                </div>
              </div>
              : null
          }

          { this.props.f == 6 ? 
              <div className="row toggle-form">
                <label>Mon permis a été<span className="reqField">*</span></label>
                <div className="radio">
                  <input id="annul1"
                         name="annul"
                         value="annule"
                         type="radio"
                         onChange={this.handleDataChange}
                         defaultChecked={this.props.fieldValues.prospect_permis_statut == "annule" ? true : false}/>
                  <label htmlFor="annul1" className="radio-label lnk">annulé</label>
                </div>
                <div className="radio">
                  <input id="annul2"
                         name="annul"
                         value="suspendu"
                         type="radio"
                         onChange={this.handleDataChange}
                         defaultChecked={this.props.fieldValues.prospect_permis_statut == "suspendu" ? true : false}/>
                  <label htmlFor="annul2" className="radio-label lnk">suspendu</label>
                </div>
              </div>
              : null
          }
          
          {
            (this.props.f <= 2) ?
              <div className="row toggle-form">
                <label>De préférence, je souhaite passer le permis<span className="reqField">*</span></label>
                <div className="radio">
                  <input id="pref1"
                         name="province"
                         value="paris"
                         type="radio"
                         onChange={this.handleDataChange}
                         defaultChecked={this.props.fieldValues.prospect_preference_pass == "paris" ? true : false}/>
                  <label htmlFor="pref1" className="radio-label lnk">à Paris</label>
                </div>
                <div className="radio">
                  <input id="pref2"
                         name="province"
                         value="province"
                         type="radio"
                         onChange={this.handleDataChange}
                         defaultChecked={this.props.fieldValues.prospect_preference_pass == "province" ? true : false}/>
                  <label htmlFor="pref2" className="radio-label lnk">en province</label>
                </div>
              </div>
              : null
          }
          {
            (this.props.f == 7) ?
              <div>
                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="bateauEcole" className="lnk">J'ai déjà été inscrit dans une bateau-école</label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="bateauEcole"
                      defaultChecked={this.props.fieldValues.prospect_formation_bateau}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="bateauEcole"/>
                    <p className="label-toggle">{this.state.prospect_formation_bateau == true ? "Oui" : "Non"}</p>
                  </div>
                </div>


                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="hourNav" className="lnk">J'ai déjà effectué des heures de navigation</label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="hourNav"
                      defaultChecked={this.props.fieldValues.prospect_heure_navigation}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="hourNav"/>
                    <p className="label-toggle">{this.state.prospect_heure_navigation == true ? "Oui" : "Non"}</p>
                  </div>
                  <div className="twelve columns" style={{display: displayNbHourNav}}>
                    <label htmlFor="nbHourNav" className="lnk">Combien d'heure(s) ?</label>
                    <input id="nbHourNav"
                           type="number"
                           ref="nbHourNav"
                           min="1" max="100"
                           defaultValue={this.props.fieldValues.prospect_nb_heure_navigation != null ? this.props.fieldValues.prospect_nb_heure_navigation : ""}
                           onChange={() => {this.handleDataChange(); this.validationForm(); }}
                           onKeyDown={(e) =>  {this.checkInput(e)}}/>
                    {errorMsg != false ? this.state.error_message : null}
                  </div>
                </div>
              </div>
              : null
          }
          {
            (this.props.f >= 8) ?
              <div>
                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="avionEcole" className="lnk">J'ai déjà été inscrit dans une école d'aviation</label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="avionEcole"
                      defaultChecked={this.props.fieldValues.prospect_formation_avion}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="avionEcole"/>
                    <p className="label-toggle">{this.state.prospect_formation_avion == true ? "Oui" : "Non"}</p>
                  </div>
                </div>
                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="hourFlight" className="lnk">J'ai déjà effectué des heures de vol</label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="hourFlight"
                      defaultChecked={this.props.fieldValues.prospect_heure_vol}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="hourFlight"/>
                    <p className="label-toggle">{this.state.prospect_heure_vol == true ? "Oui" : "Non"}</p>
                  </div>
                  <div className="twelve columns" style={{display: displayNbHourFlight}}>
                    <label htmlFor="nbHourFlight" className="lnk">Combien d'heure(s) ?</label>
                    <input id="nbHourFlight"
                           type="number"
                           ref="nbHourFlight"
                           min="1" max="100"
                           defaultValue={this.props.fieldValues.prospect_nb_heure_vol != null ? this.props.fieldValues.prospect_nb_heure_vol : ""}
                           onChange={() => {this.handleDataChange(); this.validationForm(); }}
                           onKeyDown={(e) =>  {this.checkInput(e)}}/>
                    {errorMsg != false ? this.state.error_message : null}
                  </div>
                </div>
                <div className="row toggle-form">
                  <div className="nine columns">
                    <label htmlFor="licencePPL" className="lnk">Vous avez déjà une licence PPL {this.props.f > 8 ? "Avion" : "Helicopter"} ? </label>
                  </div>
                  <div className="three columns">
                    <Toggle
                      id="licencePPL"
                      defaultChecked={this.props.fieldValues.prospect_permis_ppl}
                      icons={false}
                      onChange={this.handleDataChange}
                      ref="licencePPL"/>
                    <p className="label-toggle">{this.state.prospect_permis_ppl == true ? "Oui" : "Non"}</p>
                  </div>
                </div>
              </div>
              : null
          }

          <div className="row toggle-form">
            <label>De préférence, je souhaite être contacté par l'agence<span className="reqField">*</span></label>
            {Object.keys(agency).map(function(a, index){
              return (<div key={"agency_"+index} className="radio">
                        <input id={"ecole_"+index}
                               name="ecole"
                               value={agency[a].id}
                               type="radio"
                               onChange={that.handleDataChange}
                               defaultChecked={that.props.fieldValues.prospect_preference_contact == agency[a].id ? true : false}
                        />
                        <label htmlFor={"ecole_"+index} className="radio-label lnk">{agency[a].name}</label>
                      </div>)
            })}
          </div>
          <div className="row toggle-form">
            <label htmlFor="message" className="lnk">Un petit mot pour la fin ?</label>
            <textarea id="message"
                      ref="message"
                      maxLength="600"
                      onChange={this.handleDataChange}
                      defaultValue={this.props.fieldValues.prospect_message === null ? "" : this.props.fieldValues.prospect_message}></textarea>
          </div>
          <div className="row toggle-form info">
            <p><span className="reqField">*</span>Champs obligatoires</p>
          </div>
        </div>
        {btnNext}
        <ReactTooltip effect="solid"/>
      </div>
    </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./go/views/components/signup/complement.jsx